import axiosClient from "../axios/axiosClient";

export function getGraduationStatistics() {
  return axiosClient.get("/graduation-stats");
}

export function getGraduationStatistic(graduationStatisticsId) {
  return axiosClient.get(`/graduation-stats/${graduationStatisticsId}`);
}

export function createGraduationStatistics(data) {
  return axiosClient.post("/graduation-stats", data);
}

export const updateGraduationStatistics = (graduationStatisticsId, data) => {
  return axiosClient.put(`/graduation-stats/${graduationStatisticsId}`, data);
};

export function deleteGraduationStatistics(graduationStatisticsId) {
  return axiosClient.delete(`/graduation-stats/${graduationStatisticsId}`);
}

export const batchUpdateGraduationStatistics = (data) => {
  return axiosClient.put("/graduation-stat/batch-update", data);
};
